import axios from "axios";
import { useEffect, useRef, useState } from "react";

const WorkTrack = () => {

  const [AllDates, setAllDates] = useState([])
  const [selectedDate, setSelectedDate] = useState(null)
  const [curatorData, setCuratorData] = useState([])
  useEffect(() => {
    const datesArray = []
    let day = new Date()
    for (let i = 0; i < 31; i++) {
      const newDate = new Date(day.getTime() - i * (24000 * 3600))
      datesArray.push(`${newDate.getDate()}-${newDate.getMonth() + 1}-${newDate.getFullYear()}`)
    }
    setAllDates(datesArray)
    setSelectedDate(datesArray[0])
  }, [])


  const getCuratorCounts = async (signal) => {
    if (!selectedDate)
      return

    const response = await axios.get(`/api/admin/curator-counts?date=${selectedDate}`)
    setCuratorData(response.data)

  }

  useEffect(() => {
    const abortController = new AbortController()
    const signal = abortController.signal

    getCuratorCounts(signal)
    return () => {
      abortController.abort()
    }
  }, [selectedDate])

  return <div>
    <h1 className="text-center font-semibold my-4 text-2xl">Curator image counts</h1>
    <select value={selectedDate} onChange={e => setSelectedDate(e.target.value)} className="mx-2 p-2 font-medium rounded py-1">
      <option disabled>Select a date</option>
      {AllDates.map(item => <option value={item}>{item}</option>)}
    </select>

    <table className="table border-collapse border border-slate-400 table-auto w-[90%] mx-2 my-4">
      <thead>
        <tr className="border">
          <th >User Key</th>
          <th>Images count</th>
          <th>Categories count</th>
        </tr>
      </thead>
      <tbody className="text-center">
        {curatorData.map(curator => <tr key={curator.username} className="py-1 odd:bg-slate-200 even:bg-white border border-slate-400">
          <td>{curator.username}</td>
          <td>{curator.count}</td>
          <td>{curator.categoryCount}</td>
        </tr>)}

      </tbody>

    </table>

  </div>
}

export default WorkTrack;
